/* ------------------------------------------------------------------
   ATELIER SAJADA - Cohesion des groupes du panier
   ------------------------------------------------------------------
   Quand le client retire un produit qui porte des options, ou change sa
   quantite, les lignes d'option doivent suivre. Le theme n'envoie une
   requete que pour la ligne cliquee.

   On intercepte cette requete vers /cart/change.js et on la transforme en
   une requete /cart/update.js unique qui applique la meme quantite au
   parent et a toutes ses options. Un seul aller-retour : c'est le theme
   qui redessine le panier, aucun conflit avec Horizon.

   Liaison reconnue : _box_ligne (parent) <-> _box_parent (option)

   A charger depuis layout/theme.liquid, avant </body>, en balise classique
   (jamais depuis un snippet du tiroir panier) :
     <script src="{{ 'ats-panier-groupes.js' | asset_url }}" defer></script>
------------------------------------------------------------------ */

(function () {
  'use strict';

  if (window.__atsPanierGroupes) return;
  window.__atsPanierGroupes = true;

  function prop(item, nom) {
    return item && item.properties ? item.properties[nom] : null;
  }

  /* ---------------------------------------------------------------
     Cles des lignes d'option rattachees a un parent donne.
     Retourne un tableau vide si la ligne est elle-meme une option.
     --------------------------------------------------------------- */
  function enfantsDe(items, cleParent) {
    var index = -1;
    for (var i = 0; i < items.length; i++) {
      if (items[i].key === cleParent) {
        index = i;
        break;
      }
    }
    if (index === -1) return [];

    var parent = items[index];
    if (prop(parent, '_box_parent')) return [];

    var cles = [];
    var ligne = prop(parent, '_box_ligne');
    if (ligne) {
      items.forEach(function (it) {
        if (prop(it, '_box_parent') === ligne) cles.push(it.key);
      });
    }
    return cles;
  }

  function chargerPanier() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json();
    });
  }

  /* ---------------------------------------------------------------
     Transforme le corps d'un /cart/change.js en corps /cart/update.js.
     Renvoie null quand il n'y a rien a grouper : la requete d'origine
     part alors telle quelle.
     --------------------------------------------------------------- */
  function transformer(corpsTexte) {
    var corps;
    try {
      corps = JSON.parse(corpsTexte);
    } catch (e) {
      return Promise.resolve(null);
    }

    if (typeof corps.quantity === 'undefined') return Promise.resolve(null);
    if (corps.updates) return Promise.resolve(null);

    return chargerPanier()
      .then(function (panier) {
        var items = panier.items || [];
        var cleParent = null;
        var i;

        if (typeof corps.id === 'string' && corps.id.indexOf(':') !== -1) {
          cleParent = corps.id;
        } else if (corps.line) {
          var ligne = items[parseInt(corps.line, 10) - 1];
          cleParent = ligne ? ligne.key : null;
        } else if (typeof corps.id !== 'undefined') {
          for (i = 0; i < items.length; i++) {
            if (String(items[i].id) === String(corps.id)) {
              cleParent = items[i].key;
              break;
            }
          }
        }

        if (!cleParent) return null;

        var enfants = enfantsDe(items, cleParent);
        if (!enfants.length) return null;

        var updates = {};
        updates[cleParent] = corps.quantity;
        enfants.forEach(function (cle) {
          updates[cle] = corps.quantity;
        });

        /* On conserve sections / sections_url : le theme doit recevoir
           exactement le HTML qu'il attend en retour. */
        var nouveau = {};
        Object.keys(corps).forEach(function (k) {
          if (k !== 'id' && k !== 'line' && k !== 'quantity' && k !== 'properties') {
            nouveau[k] = corps[k];
          }
        });
        nouveau.updates = updates;

        return JSON.stringify(nouveau);
      })
      .catch(function () {
        return null;
      });
  }

  var fetchOrigine = window.fetch;

  window.fetch = function (entree, options) {
    var url = '';
    try {
      url = typeof entree === 'string' ? entree : (entree && entree.url) || '';
    } catch (e) {
      return fetchOrigine.apply(this, arguments);
    }

    var corpsTexte = options && typeof options.body === 'string' ? options.body : null;

    if (url.indexOf('/cart/change') === -1 || !corpsTexte) {
      return fetchOrigine.apply(this, arguments);
    }

    var contexte = this;

    return transformer(corpsTexte).then(function (nouveauCorps) {
      if (!nouveauCorps) {
        return fetchOrigine.call(contexte, entree, options);
      }
      var nouvellesOptions = {};
      Object.keys(options).forEach(function (k) {
        nouvellesOptions[k] = options[k];
      });
      nouvellesOptions.body = nouveauCorps;
      return fetchOrigine.call(contexte, url.replace('/cart/change', '/cart/update'), nouvellesOptions);
    });
  };
})();